Pluswerk.PlusProject.Utility.ReplaceUrlSegmentController = {
  selector: '.js-append-url-segment',
  init: function () {
    var instance = Pluswerk.PlusProject.Utility.ReplaceUrlSegmentController;
    var $replaceElement = $(instance.selector);
    if ($replaceElement.length && window.location.hash) {
      $replaceElement.html(window.location.hash.substring(1));
    }
  }
};
